import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";
import html2canvas from "html2canvas";

const VehicleHiringEntryPORPrint = ({ entryDetail: entry }) => {
    if (!entry) return null;
    const printTime = new Date().toLocaleString("en-US", {
        dateStyle: "medium",
        timeStyle: "medium",
    });
    return (
        <div
            style={{
                fontFamily: "sans-serif",
                width: "210mm",
                height: "297mm",
                boxSizing: "border-box",
                background: "white",
                color: "#000000",
                margin: 0,
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 16,
            }}
        >
            <div
                style={{
                    backgroundColor: "white",
                    border: "2px solid black",
                    width: "100%",
                    height: "100%",
                    boxSizing: "border-box",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                }}
            >
                {/* Header */}
                <div
                    style={{
                        padding: 16,
                        borderBottom: "2px solid black",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <div style={{ flex: "0 0 auto", marginRight: "16px" }}>
                        <img
                            src={entry?.entity?.logo?.url || "/logonew.png"}
                            alt="Logo"
                            style={{ height: "60px" }}
                        />
                    </div>
                    <div>
                        <div style={{ fontSize: 22, fontWeight: "bold", textAlign: "center" }}>
                            Vehicle Hiring Receipt
                        </div>
                        <div style={{ fontSize: 14, textAlign: "center", marginTop: 4 }}>
                            {entry?.entity?.displayName || entry?.entity?.name || "Entity Name"}
                        </div>
                    </div>
                </div>
                {/* Hiring & Vehicle Details */}
                <div style={{ display: "flex", borderBottom: "1px solid #ccc" }}>
                    <div style={{ flex: 1, padding: 16 }}>
                        <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
                            Hiring Details
                        </div>
                        <div style={{ fontSize: 14 }}>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Receipt ID:</strong> #{entry?._id?.substring(0, 8).toUpperCase()}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>From (Origin):</strong> {entry?.sourceBranch?.name || "N/A"}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>To (Destination):</strong> {entry?.destinationBranch?.name || "N/A"}
                            </div>
                            <div style={{ marginBottom: 4, fontSize: 13, marginTop: 4, wordBreak: "break-word" }}>
                                <strong>Present Hiring Dates:</strong>{" "}
                                {(() => {
                                    const absentDatesSet = new Set(
                                        (entry?.absentDates || []).map(d => moment(d).format("MM/DD/YYYY"))
                                    );
                                    const presentDates = (entry?.hiringDates || [])
                                        .filter(d => !absentDatesSet.has(moment(d).format("MM/DD/YYYY")))
                                        .sort((a, b) => new Date(a) - new Date(b));
                                    if (presentDates.length === 0) return "N/A";
                                    return presentDates
                                        .map((date) => moment(date).format("MM/DD/YYYY"))
                                        .join(", ");
                                })()}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Created Date:</strong>{" "}
                                {entry?.createdAt ? moment(entry?.createdAt).format("MM/DD/YYYY") : "N/A"}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Created By:</strong> {entry?.createdBy?.name || "N/A"}
                            </div>
                        </div>
                    </div>
                    <div style={{ flex: 1, padding: 16, borderLeft: "1px solid #ccc" }}>
                        <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
                            Vehicle Information
                        </div>
                        <div style={{ fontSize: 14 }}>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Vehicle Reg. No:</strong> {entry?.vehicleRegistrationNumber?.registration_number || "N/A"}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Vehicle Type:</strong> {entry?.vehicleType || "N/A"}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Hiring Type:</strong> {entry?.hiringType || "N/A"}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Hiring Fare:</strong> {entry?.hiringFare ?? "N/A"}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Total Fare:</strong> {entry?.totalFare ?? "N/A"}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Owner & Driver Information */}
                <div style={{ display: "flex", borderBottom: "1px solid #ccc" }}>
                    <div style={{ flex: 1, padding: 16 }}>
                        <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
                            Owner Information
                        </div>
                        <div style={{ fontSize: 14 }}>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Name:</strong> {entry?.ownerName || "N/A"}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Phone:</strong> {entry?.ownerNumber || "N/A"}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Bank Name:</strong> {entry?.bankAccountDetails?.bankName || "N/A"}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Bank Account Name:</strong> {entry?.bankAccountDetails?.accountName || "N/A"}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Account No:</strong> {entry?.bankAccountDetails?.accountNumber || "N/A"}
                            </div>
                        </div>
                    </div>
                    <div style={{ flex: 1, padding: 16, borderLeft: "1px solid #ccc" }}>
                        <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
                            Driver Information
                        </div>
                        <div style={{ fontSize: 14 }}>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Name:</strong> {entry?.driverName || "N/A"}
                            </div>
                            <div style={{ marginBottom: 4 }}>
                                <strong>Phone:</strong> {entry?.driverNumber || "N/A"}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Purpose & Approval */}
                <div style={{ padding: 16, borderBottom: "1px solid #ccc" }}>
                    <div style={{ fontWeight: "bold", fontSize: 15, marginBottom: 6 }}>
                        Additional Details
                    </div>
                    <div style={{ fontSize: 13 }}>
                        <div style={{ marginBottom: 6 }}>
                            <strong>Purpose of Hiring:</strong>{" "}
                            {entry?.purposeOfHiring || "N/A"}
                        </div>
                        <div style={{ marginBottom: 6 }}>
                            <strong>Approval Status:</strong>{" "}
                            {entry?.approvalStatus || "Pending"}
                        </div>
                        <div style={{ marginBottom: 6 }}>
                            <strong>Approved By:</strong>{" "}
                            {entry?.reviewedBy?.name || "N/A"}
                            {entry?.reviewedAt && ` on ${moment(entry?.reviewedAt).format("MM/DD/YYYY hh:mm A")}`}
                        </div>
                    </div>
                </div>
                {/* Footer */}
                <div
                    style={{
                        borderTop: "2px solid black",
                        textAlign: "center",
                        padding: 10,
                        fontSize: 14,
                        marginTop: "auto",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <div style={{ fontSize: 12, color: "#555" }}>Printed on: {printTime}</div>
                    <div>Thank you for choosing our service.</div>
                </div>
            </div>
            <style>
                {`
          @media print {
            html, body, #hiring-receipt, #hiring-receipt > div {
              width: 210mm !important;
              height: 297mm !important;
              min-width: 210mm !important;
              min-height: 297mm !important;
              max-width: 210mm !important;
              max-height: 297mm !important;
              margin: 0 !important;
              padding: 0 !important;
              box-sizing: border-box !important;
              background: white !important;
            }
            @page {
              size: A4 portrait;
              margin: 0;
            }
          }
        `}
            </style>
        </div>
    );
};

export const generateVehicleHiringPOR = (entryDetail) => {
    const labelWindow = window.open("", "_blank");
    if (!labelWindow) {
        console.error("Failed to open new window for printing");
        return;
    }
    labelWindow.document.write(`
    <html>
      <head>
        <title>Vehicle Hiring Receipt</title>
        <style>
          @media print {
            body * { visibility: hidden; }
            #hiring-receipt, #hiring-receipt * { visibility: visible; }
            #hiring-receipt { position: absolute; left: 0; top: 0; width: 100%; height: 100%; margin: 0; padding: 0; box-shadow: none; }
            @page { margin: 0; size: auto; }
          }
        </style>
      </head>
      <body>
        <div id="hiring-receipt" style="display: flex; justify-content: center; align-items: center;"></div>
      </body>
    </html>
  `);
    labelWindow.document.close();
    setTimeout(() => {
        const root = labelWindow.document.getElementById("hiring-receipt");
        if (root) {
            const element = document.createElement("div");
            root.appendChild(element);
            try {
                ReactDOM.render(
                    <VehicleHiringEntryPORPrint entryDetail={entryDetail} />,
                    element
                );
            } catch (error) {
                console.error("ReactDOM.render error:", error);
            }
        } else {
            console.error("hiring-receipt element not found");
        }
    }, 100);
};

export default VehicleHiringEntryPORPrint;

export const generateVehicleHiringPORImage = (entryDetail) => {
    return new Promise((resolve, reject) => {
        const container = document.createElement("div");
        container.style.position = "fixed";
        container.style.top = "0";
        container.style.left = "0";
        container.style.zIndex = "-9999";
        container.style.pointerEvents = "none";
        container.style.color = "#000000";
        document.body.appendChild(container);
        try {
            ReactDOM.render(
                <VehicleHiringEntryPORPrint entryDetail={entryDetail} />,
                container
            );
        } catch (error) {
            document.body.removeChild(container);
            reject(error);
            return;
        }
        const waitForImages = (root) => {
            const imgs = Array.from(root.querySelectorAll("img"));
            if (imgs.length === 0) return Promise.resolve();
            return Promise.all(
                imgs.map((img) => {
                    if (img.complete && img.naturalWidth > 0) return Promise.resolve();
                    return new Promise((res) => {
                        img.addEventListener("load", res, { once: true });
                        img.addEventListener("error", res, { once: true });
                        setTimeout(res, 3000);
                    });
                })
            );
        };
        requestAnimationFrame(async () => {
            const target = container.firstElementChild || container;
            await waitForImages(target);
            await document.fonts.ready; // ensure fonts are loaded before capture
            try {
                const canvas = await html2canvas(target, {
                    scale: 2,
                    useCORS: true,
                    backgroundColor: "#ffffff",
                    width: target.scrollWidth,
                    height: target.scrollHeight,
                });
                const link = document.createElement("a");
                const regNumber = entryDetail?.vehicleRegistrationNumber?.registration_number || "receipt";
                const todayDate = moment().format("YYYY-MM-DD");
                link.download = `POR_Vehile_Hire_${regNumber}_${todayDate}.png`;
                link.href = canvas.toDataURL("image/png");
                link.click();
                resolve();
            } catch (error) {
                console.error("html2canvas error:", error);
                reject(error);
            } finally {
                ReactDOM.unmountComponentAtNode(container);
                document.body.removeChild(container);
            }
        });
    });
};